export const ADD_RESULTS = "ADD_RESULTS";
